import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';
import iView from 'iview';
import Util from '../lib/util';
import Cookies from 'js-cookie'
import { appRouters,otherRouters   , changePasswordRouter} from './router'

Vue.use(VueRouter);

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


const RouterConfig = {
    // mode: 'history',
    routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
	if(to.name=='ilearningErrorPage')
	{
		 window.document.title = 'i-learning'
	}else
	if(to.name!=='newsdetail' && to.name!=='noticedetail' && to.name!=='xuexidetail'&& to.name!=='commentaudit' 
	&& to.name!=='mustreaddetail' && to.name!=='testquestion'  && to.name!=='questionnaire' && to.name!=='vote'
	&& to.name!=='voteuser' && to.name!=='questionnaireuser'&& to.name!=='testquestionuser'){
		Util.title(to.meta.title);
	} 
    else{
		 window.document.title = '延锋彼欧GIS'
	}
	
	
    if (Cookies.get('locking') === '1' && to.name !== 'locking') {
        next({
            replace: true,
            name: 'locking'
        });
    }else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
        if (!Util.abp.session.userId&& to.name !== 'login' && to.name!=='newsdetail'&& to.name!=='mustreaddetail' && to.name!=='statistics' && to.name!=='noticedetail' && to.name!=='xuexidetail' 
		&& to.name!=='download' && to.name!=='downloadnew' && to.name!=='newsgroup'&& to.name!=='commentaudit'&& to.name!=='forgetpassword' && to.name!=='accountactivation' 
		&& to.name!== 'downloadafter' && to.name!=='testquestion' && to.name!=='questionnaire' && to.name!=='vote'
		&& to.name!=='voteuser' && to.name!=='questionnaireuser'&& to.name!=='testquestionuser' && to.name!=='ilearningErrorPage' && to.name!=='sessionai' && to.name!=='sessionainew' && to.name!=='sessionai2') {
			
				next({
				    name: 'login'
				});
			

        } else if (!!Util.abp.session.userId && to.name === 'login') {
            Util.title(to.meta.title);
                next({
                    name: 'home'
                });
        } else {
            const curRouterObj = Util.getRouterObjByName([otherRouters,changePasswordRouter, ...appRouters], to.name);
            if (curRouterObj && curRouterObj.permission) {
                if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                    Util.toDefaultPage([otherRouters,changePasswordRouter, ...appRouters], to.name, router, next);
                } else {
                    next({
                        replace: true,
                        name: 'error-403'
                    });
                }
            } else {
                Util.toDefaultPage([...routers], to.name, router, next);
            }
        }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});